import { useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import options from './options';

function HeatMapAlcanceUnidades({ dadosGraf }) {

    const preencherDadosFaltantesParaGraficos = (dataToFiller) => {
        const todosOsMeses = new Set();
        dataToFiller.forEach(data => {
            data.indicadores.forEach(indicador => {
                todosOsMeses.add(indicador.mesReferenciaFormatado)
            });
        });
        // Criar uma nova versão dos dados com os valores ausentes preenchidos
        return dataToFiller.map(data => ({
            codigo: `Indicador ${data.codigo}`,
            indicadores: Array.from(todosOsMeses).sort((a, b) => a - b).map(x => {
                const encontrado = data.indicadores.find(d => d.mesReferenciaFormatado === x);
                return { mesReferenciaFormatado: x, percentAlcancado: encontrado ? encontrado.percentAlcancado : -1 }; // Usa -1 para preencher
            })
        }));
    }

    dadosGraf = preencherDadosFaltantesParaGraficos(dadosGraf)

    const series = dadosGraf.map(item => ({
        name: item.codigo,
        data: item.indicadores.reverse()
    }));

    console.log(series);

    return (
        <div className='h-100 div-com-borda'>
            <Chart

                options={options}
                series={series}
                type="heatmap"
                height="100%"
            />
        </div>
    );

}

export default HeatMapAlcanceUnidades
